import api from '../api'
export default {
	namespaced: true,
	state: {
		permissionList: [],
		permissionTotal: ''
	},
	mutations: {
		GET_PERMISSION_LIST( state, data = {} ) {
			state.permissionList = data.records
			state.permissionTotal = data.total
		}
	},
	actions: {
		GET_PERMISSION_LIST( { commit, dispatch },  config ) {
			return api.getPermissionList( config ).then(( res ) => {
				commit( 'GET_PERMISSION_LIST', res.payload )
				return res
			}).catch(( rej ) => {
				window.myVue.$message.error( rej.message )
			})
		},
		GET_PERMISSION_DETAIL ({ commit, dispatch }, config) {
			return api.permissionDetail(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		DELETE_PERMISSION ({ commit, dispatch }, params) {
			return api.deletepermission({
				params: params
			}).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		ADD_PERMISSION ({ commit, dispatch }, config) {
			return api.addpermission(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		UPDATE_PERMISSION ({ commit, dispatch }, config) {
			return api.updatepermission(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/permissionManage/store/index.js